import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "palettes-copy" }
const _hoisted_3 = { class: "scene" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "set is-left" }
const _hoisted_6 = { class: "photo" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "set is-right" }
const _hoisted_9 = { class: "photo" }
const _hoisted_10 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_home_reveal = _resolveDirective("home-reveal")!

  return _withDirectives((_openBlock(), _createElementBlock("section", {
    class: "palettes",
    "aria-label": _ctx.t('paletteExplorerText')
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.t('paletteExplorerText')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.t('paletteExplorerSubText')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        class: "backdrop",
        src: _ctx.choice.src,
        alt: _ctx.t(_ctx.choice.captionKey)
      }, null, 8, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leftPalettes, (palette) => {
          return (_openBlock(), _createElementBlock("figure", {
            key: palette.titleKey
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: palette.src,
                alt: _ctx.t(palette.titleKey)
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("figcaption", null, _toDisplayString(_ctx.t(palette.titleKey)), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rightPalettes, (palette) => {
          return (_openBlock(), _createElementBlock("figure", {
            key: palette.titleKey
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                src: palette.src,
                alt: _ctx.t(palette.titleKey)
              }, null, 8, _hoisted_10)
            ]),
            _createElementVNode("figcaption", null, _toDisplayString(_ctx.t(palette.titleKey)), 1)
          ]))
        }), 128))
      ]),
      _createVNode(_component_router_link, {
        class: "scene-cta",
        to: "/signUp"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t(_ctx.choice.captionKey)), 1)
        ]),
        _: 1
      })
    ])
  ], 8, _hoisted_1)), [
    [_directive_home_reveal]
  ])
}